import axios from "axios";
import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import "../../css/Homepage.css";
import { formatDate, processHTML } from "../../utils/portfolioUtils";
import LoadingState from "../common/LoadingState";

const News = () => {
  const [updates, setUpdates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchNewsData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_API_URL}/api/homepage/updates/`,
        );
        setUpdates(response.data.results || response.data);
      } catch (err) {
        console.error("Error fetching news data:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchNewsData();
  }, []);

  if (loading) {
    return <LoadingState />;
  }

  return (
    <>
      <Helmet>
        <title>News — Kaustubh Harapanahalli</title>
        <meta
          name="description"
          content="Latest news and updates from Kaustubh Harapanahalli."
        />
      </Helmet>
      <section className="portfolio-section section-band-1">
        <Container>
          <Row>
            <Col md={{ span: 10, offset: 1 }}>
              <h2 className="page-heading">News</h2>
              {error ? (
                <p className="text-secondary">
                  Couldn&apos;t load news — please try refreshing the page.
                </p>
              ) : updates && updates.length > 0 ? (
                <div className="updates-list">
                  {updates.map((update, index) => (
                    <div key={index} className="update-row">
                      <span className="update-date">
                        {formatDate(update.date)}
                      </span>
                      <div
                        className="update-body"
                        dangerouslySetInnerHTML={{
                          __html: processHTML(update.content),
                        }}
                      />
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-secondary">
                  No news available at the moment.
                </p>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default News;
